module.exports = __webpack_public_path__ + "static/media/subscription-bg.8b5ff1ff.png";